import axios from 'axios';
import appConfig from '../config/client';

axios.defaults.baseURL = appConfig.apiUrl;

export const createShortUrl = (obj) => {
  const requestUrl = '/link';
  return axios.post(requestUrl, obj);
};
export const linkList = (searchUrlCode) => {
  let listUrl = '/linklist';

  if (searchUrlCode) {
    listUrl = listUrl + '?searchLinkCode=' + searchUrlCode;
  }
  return axios.get(listUrl);
};



// WEBPACK FOOTER //
// ./src/services/apiRequests.js